import {Package} from '../@types';

export function getUnclaimedPackagesCount(packages: Array<Package>) {
  return packages?.filter((packageItem) => packageItem.status === 'Unclaimed')
    ?.length;
}
